import React from 'react';
import Browser from '@components/Browser';

const BrowserNotes = () => {
  return (
    <div className="browser-notes">
      <Browser except firefox chrome mobile>
      <span>Hoşgeldin  <b>knka!</b></span>
      </Browser>
      <Browser only firefox>
      <span>Yılan gibisin be <b>knka</b></span>
      </Browser>
    </div>
  );
};

export default BrowserNotes;


// WEBPACK FOOTER //
// ./src/components/BrowserNotes/BrowserNotes.js